import React, { createContext, useContext, useRef } from "react";
import { Map as LeafletMap } from "leaflet";

interface MapContextType {
  map: LeafletMap | null;
  setMap: (map: LeafletMap | null) => void;
}

const MapContext = createContext<MapContextType>({
  map: null,
  setMap: () => {},
});

export const MapProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const mapRef = useRef<LeafletMap | null>(null);

  return (
    <MapContext.Provider value={{
      map: mapRef.current,
      setMap: (map) => {
        mapRef.current = map;
      }
    }}>
      {children}
    </MapContext.Provider>
  );
};

export const useMapInstance = () => {
  const context = useContext(MapContext);
  if (!context) {
    throw new Error('useMapInstance must be used within a MapProvider');
  }
  return context;
};
